import { FC, ReactNode, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
// components
// import Select from "../components/Select";
import PageHeading from "../components/PageHeading";
// import Button from "../components/Button";
import Tabs from "../components/tabs/Tabs";
// interfaces
import { IMerchantConfig } from "../@interfaces/config.interface";
import { STEPS } from "../@interfaces/tabs.interface";
// styles
import styles from "../styles/pages/estimation/EstimationPage.module.css";
import { QuoteTravelData, TravelRequestType } from "../@types/travel";


interface IEstimationPage {
  merchantCode: string,
  merchantConfig: IMerchantConfig;
  selectedCurrency: string;
  isLoading: boolean;
  onOffsetClick: (quoteRequest: QuoteTravelData, requestType: TravelRequestType ) => void;
  onFixedOffsetClick: (requestBody: any) => void;
  JourneysPageSubtitle: ReactNode;
}

const EstimationPage: FC<IEstimationPage> = ({
  merchantCode,
  merchantConfig,
  selectedCurrency,
  isLoading,
  onOffsetClick,
  onFixedOffsetClick,
  JourneysPageSubtitle,
}) => {
  const location = useLocation();
  const search = new URLSearchParams(location?.search);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const urlParams = useMemo(() => Object.fromEntries(search), []);

  const [activeTab, setActiveTab] = useState<STEPS | ''>('');

  useEffect(() => {
    setActiveTab(urlParams?.transportType in STEPS ? urlParams?.transportType as STEPS : STEPS.FLIGHT);
  }, [urlParams]);

  const estimationPage = merchantConfig?.pages?.estimation;

  const changeTab = (tab: any) => {
    setActiveTab(tab);
  };

  const getEmissionSubtitle = (activeTab: STEPS) => {
    return merchantConfig?.tabsConfig.filter((tab: any) => tab.name === activeTab)[0].subtitle;
  } 

  return (
    <div className={`${styles.container} delayed-fadein`}>
      <PageHeading
        title={estimationPage?.header?.title}
        text={activeTab && getEmissionSubtitle(activeTab)}
        subtitle={JourneysPageSubtitle}
      />

      <div className={styles.controls}>
        <Tabs
          merchantCode={merchantCode}
          changeTab={changeTab}
          activeTab={activeTab}
          onOffsetClick={onOffsetClick}
          onFixedOffsetClick={onFixedOffsetClick}
          selectedCurrency={selectedCurrency}
          isLoading={isLoading}
          urlParams={urlParams}
          merchantConfig={merchantConfig}
        />
      </div>
    </div>
  );
};

export default EstimationPage;
